import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconHighlighter20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconHighlighter20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="m14.203 4.142 2.148 2.14a.497.497 0 0 1 .028.675L10.63 13.71 6.743 9.839l6.782-5.725a.503.503 0 0 1 .678.028M5.95 11.166l-.794 2.106 2.029 2.02 2.114-.791zm6.604-8.193a2.01 2.01 0 0 1 2.713.11l2.148 2.14a1.99 1.99 0 0 1 .112 2.702l-6.029 7.083c-.22.259-.504.458-.824.578l-3.263 1.22a1 1 0 0 1-.745-.016l-.817.749c-.324.296-.747.46-1.187.46h-.904c-1.578 0-2.353-1.912-1.218-3.003l1.158-1.113a1 1 0 0 1-.063-.837l1.226-3.25a2 2 0 0 1 .58-.82zm-7.82 11.995.815.812-.717.657a.25.25 0 0 1-.17.065h-.904a.25.25 0 0 1-.174-.429zM12.75 16.5a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconHighlighter20);
